export const RatePlanCalculationTypeEnum = Object.freeze({
    VALUE: 'VALUE',
    QUANTITY: 'QUANTITY'
});

export default RatePlanCalculationTypeEnum;
